import React, { useState, useEffect } from 'react';
import { isMobile } from "../App/utils";
import { Button, Snackbar } from "@mui/material";
import { isMac } from "../utils";

export const InstallPWAButton = ({ KB, isPWA, installPrompt, isActive }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const pwaInstalled = urlParams.get('pwaInstalled') === 'true';
    const [snackbarOpen, setSnackbarOpen] = useState(pwaInstalled);

    const handleInstallClick = () => {
        const iphone = isMac() && isMobile;

        if (iphone) {
            setSnackbarOpen(true)
            return
        }

        installPrompt.prompt();
        installPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the install prompt');
                // window.location.href = `${window.location.pathname}?pwaInstalled=true`;
            } else {
                console.log('User dismissed the install prompt');
            }
        });
    };

    const calculateFontSize = (title) => {
        let fontSize = 22 * 0.875 * (22 / title.length);
        fontSize = Math.max(8, fontSize);
        fontSize = Math.min(12, fontSize);
        return fontSize;
    };

    const title = isActive
        ? `Add to Home Screen`
        : `Add to Home (pending app engagement ...)`;

    const fontSize = calculateFontSize(title);
    const iphone = isMac() && isMobile;

    const safariShareIcon = (
        <svg width="24px" height="24px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" style={{
            verticalAlign: 'text-bottom', marginLeft: '5px', marginRight: '5px', marginTop: -5 }}>
            <g fill="none" fillRule="evenodd">
                <g fill="#212121" fillRule="nonzero">
                    <path d="M37.75,20.25 C38.6681734,20.25 39.4211923,20.9571103 39.4941988,21.8564728 L39.5,22 L39.5,36.25 C39.5,39.3517853 37.0439828,41.879937 33.9705557,41.9958479 L33.75,42 L14.25,42 C11.1482147,42 8.62006299,39.5439828 8.50415208,36.4705557 L8.5,36.25 L8.5,22 C8.5,21.0335017 9.28350169,20.25 10.25,20.25 C11.1681734,20.25 11.9211923,20.9571103 11.9941988,21.8564728 L12,22 L12,36.25 C12,37.440864 12.9251616,38.4156449 14.0959512,38.4948092 L14.25,38.5 L33.75,38.5 C34.940864,38.5 35.9156449,37.5748384 35.9948092,36.4040488 L36,36.25 L36,22 C36,21.0335017 36.7835017,20.25 37.75,20.25 Z M23.4989075,6.26787884 L23.6477793,6.25297693 L23.6477793,6.25297693 L23.8225053,6.25140103 L23.8225053,6.25140103 L23.9770074,6.26441014 L23.9770074,6.26441014 L24.1549097,6.29667263 L24.1549097,6.29667263 L24.223898,6.31492315 L24.223898,6.31492315 C24.4192207,6.36884271 24.6069182,6.4577966 24.7773762,6.58126437 L24.8968901,6.67628678 L24.8968901,6.67628678 L24.989825,6.76256313 L32.7679996,14.5407377 C33.4514171,15.2241552 33.4514171,16.3321939 32.7679996,17.0156115 C32.1247831,17.6588279 31.1054316,17.6966642 30.4179639,17.1291203 L30.2931259,17.0156115 L25.5,12.222 L25.5,31.5 C25.5,32.4181734 24.7928897,33.1711923 23.8935272,33.2441988 L23.75,33.25 C22.8318266,33.25 22.0788077,32.5428897 22.0058012,31.6435272 L22,31.5 L22,12.226 L17.2116504,17.0156115 C16.5684339,17.6588279 15.5490824,17.6966642 14.8616148,17.1291203 L14.7367767,17.0156115 C14.0935602,16.372395 14.055724,15.3530435 14.6232679,14.6655758 L14.7367767,14.5407377 L22.488804,6.78678454 C22.5446792,6.72871358 22.6045271,6.67449255 22.6679103,6.62455868 L22.7812362,6.54379243 L22.7812362,6.54379243 C22.8189499,6.51724 22.858413,6.49312256 22.8988638,6.47056335 L22.9176605,6.46138558 C23.0947495,6.36422067 23.2909216,6.29776289 23.4989075,6.26787884 Z" />
                </g>
            </g>
        </svg>
    );

    return isMobile && !isPWA && (
        <>
            <div style={{

            }}>
                {(installPrompt || iphone) && KB.kbTitle && (
                    <span
                        variant="contained"
                        color="secondary"
                        onClick={handleInstallClick}

                    >
                        {title}
                    </span>
                )}
            </div>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={30000}
                onClose={() => setSnackbarOpen(false)}
                message={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        On your iPhone tap {safariShareIcon} and select <b style={{marginLeft: 8}}> 'Add to Home Screen'</b>.
                    </span>
                }
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
        </>
    );
};